import {post} from "./httpClient";
import {LevelData, LevelPackData} from "./models/levelData";

interface ListLevelsResponse {
    levels: LevelData[];
}

class AppApiImpl {
    private ApiUrl = 'https://clash-arena-server.pages.dev/';

    async listLevels(): Promise<LevelData[]> {
        const response = await post(this.buildApiUrl('listLevels'), '{}');
        if (!response.success) {
            return [];
        }

        const responseData = response.data as ListLevelsResponse;
        return responseData.levels;
    }

    async getLevel(levelId: string): Promise<LevelPackData> {
        const payload = JSON.stringify({
            levelId: levelId,
        })

        const response = await post(this.buildApiUrl('getLevel'), payload);
        if (!response.success) {
            return {} as LevelPackData;
        }

        return response.data as LevelPackData;
    }

    private buildApiUrl(endpoint: string): string {
        return `${this.ApiUrl}${endpoint}`;
    }
}

export const AppApi: AppApiImpl = new AppApiImpl();
